import { defaultMeta } from '@/constants/defaultMeta';
import { parseDateRangeSearch } from '@/lib/parseDateRange';
import { sortBy } from '@/lib/sortBy';
import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { premiumStoresListQueries } from '@/services/premiumStores/premiumStores.queries';
import { StatusType } from '@/services/premiumStores/premiumStores.types';
import { useSearch } from '@tanstack/react-router';

export const usePremiumStoresList = (type: StatusType) => {
  // const params = useParams(type);
  const search = useSearch({ from: '/(app)/store-information/premium-stores/' });
  const { createdDate, page, fetch, sort, q, status, locationFilter } = search;
  const parsedCreatedDate = parseDateRangeSearch(createdDate, { start: 0, end: 0 });

  const { data, isFetched, isLoading } = useQuery({
    ...premiumStoresListQueries.list(type, {
      fromDate: parsedCreatedDate?.start ?? 0,
      toDate: parsedCreatedDate?.end ?? 0,
      row: page ?? 0,
      fetch: fetch ?? 10,
      approvalStatus: type,
      search: q ?? '',
      status: status ?? '',
      location: locationFilter ?? '',
    }),
    select: (res) => ({
      ...res,
      data: sortBy(res.data ?? [], sort),
    }),
  });
  return { premiumStores: data?.data || [], isFetched, isLoading, meta: data?.meta?.pagination ?? defaultMeta };
};
